import { createFileRoute, redirect } from '@tanstack/react-router'
import PendingApprovalPage from '@/views/pending-approval'
import { useAuthStore } from '@/stores/authStore'

export const Route = createFileRoute('/auth/pending-approval')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (!auth.user) {
      throw redirect({ to: '/auth/login' })
    }
  },
  component: PendingApprovalPage,
})
